import { render, staticRenderFns } from "./GrievanceForm.vue?vue&type=template&id=77655930&scoped=true&"
import script from "./GrievanceForm.vue?vue&type=script&lang=ts&"
export * from "./GrievanceForm.vue?vue&type=script&lang=ts&"
import style0 from "./GrievanceForm.vue?vue&type=style&index=0&id=77655930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77655930",
  null
  
)

/* custom blocks */
import block0 from "./GrievanceForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports